var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSapAriba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7145 32.1761L21.6643 6H24.7735C25.4048 6 25.8957 6.30602 26.1529 6.82389L40.2031 33H37.0938C36.5328 33 35.9717 32.694 35.7145 32.1761ZM9.34397 33H12.4533C13.0845 33 13.5754 32.694 13.8326 32.1761L17.69 25.0436L15.7028 21.2772L9.34397 33ZM3.31242 33C3.94363 33 4.43457 32.694 4.69172 32.1761L15.6327 11.8143L26.5737 32.1761C26.8308 32.6704 27.3218 33 27.953 33H31.0623L17.012 6.82389C16.7548 6.32956 16.2639 6 15.6327 6C15.0716 6 14.5105 6.30602 14.2534 6.82389L0.203125 33H3.31242Z",
    fill: "#FBBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapAriba);
export default __webpack_public_path__ + "static/media/SAPAriba.23139f7eb3c7fbc7e0dc7161834bcda0.svg";
export { ForwardRef as ReactComponent };